import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css';
import '../common-styles.css';

const Header = () => {
  return (
    <Navbar expand="lg" className="custom-navbar" variant="dark" fixed="top">
      <Container className="header-navbar-container">
        <div className="header-navbar-top">
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="header-navbar-toggle" />
          <Navbar.Brand href="/" className="brand-logo header-brand-logo">
            <img src={require('../../assets/images/logo-white.png')} alt="Logo" style={{ height: '52px' }} />
          </Navbar.Brand>
          <Link to="/login" className="signin-btn header-mobile-signin" style={{ textDecoration: 'none' }}>
            <span className="signin-btn-content">
              Sign in
              <i className="fas fa-arrow-right ms-2 btn-arrow-diagonal"></i>
            </span>
          </Link>
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/process">Process</Nav.Link>
            <Nav.Link as={Link} to="/diamonds">Diamonds</Nav.Link>
            <Nav.Link as={Link} to="/artisans">Artisans</Nav.Link>
            <Nav.Link as={Link} to="/global-presence">Events</Nav.Link>
            <Nav.Link as={Link} to="/leadership">About Us</Nav.Link>
            <Nav.Link as={Link} to="/contact">Contact us</Nav.Link>
          </Nav>
          <Link to="/login" className="signin-btn header-desktop-signin" style={{ textDecoration: 'none' }}>
            <span className="signin-btn-content">
              Sign in
              <i className="fas fa-arrow-right ms-2 btn-arrow-diagonal"></i>
            </span>
          </Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
